import type { NavigationRouter } from "@app/navigation";
import type { QueryClient } from "@tanstack/react-query";

import { Providers } from "./providers";

type AppProps = {
  nonce: string;
  queryClient: QueryClient;
  router: NavigationRouter;
};

export const App = ({ nonce, queryClient, router }: AppProps) => {
  return <Providers nonce={nonce} queryClient={queryClient} router={router} />;
};
